import React from "react";
import * as SheetPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { cn } from "./utils";

export const Sheet = SheetPrimitive.Root;
export const SheetClose = SheetPrimitive.Close;

// A right-hand panel (Radix Dialog). "d2c-ui" lets the scoped border rule reach the portal.
export const SheetContent = React.forwardRef(({ className, children, ...props }, ref) => (
  <SheetPrimitive.Portal>
    <SheetPrimitive.Overlay className="tw-fixed tw-inset-0 tw-z-[1050] tw-bg-slate-900/30 data-[state=open]:tw-animate-d2c-fade-in" />
    <SheetPrimitive.Content
      ref={ref}
      className={cn(
        "d2c-ui tw-fixed tw-inset-y-0 tw-right-0 tw-z-[1051] tw-flex tw-h-full tw-w-full tw-max-w-[760px] tw-flex-col tw-border-l tw-bg-page tw-font-sans tw-text-sm tw-leading-5 tw-text-foreground tw-shadow-xl data-[state=open]:tw-animate-d2c-slide-in",
        className,
      )}
      {...props}
    >
      {children}
      <SheetPrimitive.Close className="tw-absolute tw-right-4 tw-top-4 tw-cursor-pointer tw-rounded-sm tw-bg-transparent tw-p-1 tw-text-muted-foreground tw-opacity-70 tw-transition-opacity hover:tw-opacity-100 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring">
        <X className="tw-size-4" aria-hidden="true" />
        <span className="tw-sr-only">Close</span>
      </SheetPrimitive.Close>
    </SheetPrimitive.Content>
  </SheetPrimitive.Portal>
));
SheetContent.displayName = "SheetContent";

export const SheetHeader = ({ className, ...props }) => (
  <div className={cn("tw-flex tw-flex-col tw-gap-2 tw-border-b tw-bg-background tw-px-6 tw-py-4 tw-pr-12", className)} {...props} />
);

export const SheetBody = ({ className, ...props }) => (
  <div className={cn("tw-flex-1 tw-space-y-4 tw-overflow-y-auto tw-px-6 tw-py-5", className)} {...props} />
);

export const SheetTitle = React.forwardRef(({ className, ...props }, ref) => (
  <SheetPrimitive.Title
    ref={ref}
    className={cn("tw-m-0 tw-font-sans tw-text-lg tw-font-semibold tw-leading-7 tw-text-foreground", className)}
    {...props}
  />
));
SheetTitle.displayName = "SheetTitle";

export const SheetDescription = React.forwardRef(({ className, ...props }, ref) => (
  <SheetPrimitive.Description ref={ref} className={cn("tw-m-0 tw-text-sm tw-text-muted-foreground", className)} {...props} />
));
SheetDescription.displayName = "SheetDescription";
